import { computed, onBeforeMount } from 'vue'
import isEqual from 'lodash/isEqual'
import { useStore } from 'vuex'

/**
 * Composable pour gérer les filtres avec Vuex + localStorage
 * @param {String} key - identifiant de la liste (ex: "projects", "tasks")
 * @param {Object} initialFilters - valeurs par défaut si aucun filtre n'est sauvegardé
 */
export function useFilters(key, initialFilters = {}) {
    const store = useStore()

    onBeforeMount(() => {
        store.dispatch('filters/loadFilters', { key })
    })

    const filters = computed(() => store.getters['filters/getFilters'](key) || initialFilters)

    const hasFilters = computed(() => !isEqual(filters.value, initialFilters))

    function updateFilter(newFilters) {
        store.dispatch('filters/saveFilters', {
            key,
            filters: { ...filters.value, ...newFilters }
        })
    }

    function resetFilters() {
        store.dispatch('filters/clearFilters', { key })
    }


    return {
        filters,
        updateFilter,
        hasFilters
    }
}
